export const constant = {
  Add_Dashboard: 'Add Dashboard',
  Edit: 'Edit',
  Delete: 'Delete',
  View: 'View',
  Download: 'Download',
  More: 'More'
};
